import { render, staticRenderFns } from "./submit.vue?vue&type=template&id=39cb1b40&scoped=true&"
import script from "./submit.vue?vue&type=script&lang=js&"
export * from "./submit.vue?vue&type=script&lang=js&"
import style0 from "./submit.vue?vue&type=style&index=0&id=39cb1b40&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cb1b40",
  null
  
)

export default component.exports